export const statusChangePeriodsMap = new Map([
  [
    '1',
    {
      text: '1-3 дня',
      value: [1],
      key: '1',
      min: 0,
      max: 3,
    },
  ],
  [
    '2',
    {
      text: '3-5 дней',
      value: [2],
      key: '2',
      min: 3,
      max: 5,
    },
  ],
  [
    '3',
    {
      text: '5-10 дней',
      value: [3],
      key: '3',
      min: 5,
      max: 10,
    },
  ],
  [
    '4',
    {
      text: '10-30 дней',
      value: [4],
      key: '4',
      min: 10,
      max: 30,
    },
  ],
  [
    '5',
    {
      text: 'Больше месяца',
      value: [5],
      key: '5',
      min: 30,
      max: Infinity,
    },
  ],
  [
    '',
    {
      text: 'Без учета периода',
      value: [],
      key: '6',
    },
  ],
]);

export const statusChangeDefaultPeriod = statusChangePeriodsMap.get('1');
